import { useState, useEffect } from 'react'

export function useCountdown() {
  // Fixed time as requested: 10 minutes 48 seconds
  // The requirement says "fija" (fixed), so we don't actually count down
  // But we'll return the formatted string
  return {
    minutes: 10,
    seconds: 48,
    display: '10:48',
  }
}
